module.exports = __webpack_public_path__ + "static/media/okhomelandin.3cf6acd9.svg";